import { Intent } from 'signup-constants/Intent';
import { getIntentKey } from '../../routing/getIntentKey';
import { getQueryParam } from '../../routing/getQueryParam';
export const dist030VariantAEnrollment = () => {
  const dataId = getQueryParam('dataId');
  return Boolean(dataId) && getQueryParam('external-experiment-parameter') === 'dist-0030-group-variant_a' && getIntentKey() === Intent.emailSignatureEmailTool;
};